<!-- src/views/DashboardView.vue -->

<template>
    <div class="row">
        <div class="col-md-12">


            <!-- Flickity HTML init -->
            <div ref="carousel" class="carousel">
                <div class="carousel-cell"><img src="assets/img/img1.jpg"></div>
                <div class="carousel-cell"><img src="assets/img/img1.jpg"></div>
                <div class="carousel-cell"><img src="assets/img/img1.jpg"></div>

            </div>
        </div>
        <div class="col-xxl-6">
            <!--begin::Engage widget 10-->
            <div class="card card-flush h-md-100">
                <!--begin::Body-->
                <div
                    class="card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0">
                    <!--begin::Wrapper-->
                    <div class="mb-10">
                        <!--begin::Title-->
                        <div class="col-xl-12 features">
                            <div class="d-flex h-100 align-items-center">
                                <!--begin::Option-->
                                <div class="w-100 d-flex flex-column flex-center rounded-3 bg-light bg-opacity-75 p-2">
                                    <!--begin::Heading-->
                                    <div class="mb-7 text-center">
                                        <!--begin::Title-->
                                        <h1 class="text-dark mb-1 fw-bolder">أكاديميا</h1>
                                        <!--end::Title-->
                                        <!--begin::Description-->
                                        <div class="text-gray-400 fw-semibold mb-1">
                                            <br>تعلم بلا حدود
                                        </div>
                                        <!--end::Description-->
                                        <!--begin::Price-->

                                        <!--end::Price-->
                                    </div>
                                    <!--end::Heading-->
                                    <!--begin::Features-->
                                    <img class="mx-auto h-100px h-lg-100px theme-light-show"
                                        style="width: 120px;height: 120px !important;" src="assets/img/2.png" alt="">

                                    <div class="w-100 mb-10">

                                        <!--begin::Item-->
                                        <div class="d-flex align-items-center mb-5 box">
                                            <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"> دعم فني مستمر
                                            </span>
                                            <!--begin::Svg Icon | path: icons/duotune/general/gen043.svg-->
                                            <span class="svg-icon svg-icon-1 svg-icon-success">
                                                <i class="fa-solid fa-check-circle"></i> </span>
                                            <!--end::Svg Icon-->
                                        </div>
                                        <!--end::Item-->
                                        <!--begin::Item-->
                                        <div class="d-flex align-items-center mb-5 box">
                                            <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"> طرق دفع أمنة
                                            </span>
                                            <!--begin::Svg Icon | path: icons/duotune/general/gen043.svg-->
                                            <span class="svg-icon svg-icon-1 svg-icon-success">
                                                <i class="fa-solid fa-check-circle"></i>
                                            </span>
                                            <!--end::Svg Icon-->
                                        </div>
                                        <!--end::Item-->
                                        <!--begin::Item-->
                                        <div class="d-flex align-items-center mb-5 box">
                                            <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"> باقات
                                                مخصصة</span>
                                            <!--begin::Svg Icon | path: icons/duotune/general/gen043.svg-->
                                            <span class="svg-icon svg-icon-1 svg-icon-success">
                                                <i class="fa-solid fa-check-circle"></i>
                                            </span>
                                            <!--end::Svg Icon-->
                                        </div>
                                        <!--end::Item-->
                                        <!--begin::Item-->
                                        <div class="d-flex align-items-center mb-5 box">
                                            <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3">دورات
                                                مباشرة</span>
                                            <!--begin::Svg Icon | path: icons/duotune/general/gen043.svg-->
                                            <span class="svg-icon svg-icon-1 svg-icon-success">
                                                <i class="fa-solid fa-check-circle"></i>
                                            </span>
                                            <!--end::Svg Icon-->
                                        </div>
                                        <!--end::Item-->


                                    </div>
                                    <!--end::Features-->
                                    <!--begin::Select-->
                                    <!--end::Select-->
                                </div>
                                <!--end::Option-->
                            </div>
                        </div>

                    </div>
                    <!--begin::Wrapper-->
                </div>
                <!--end::Body-->
            </div>
            <!--end::Engage widget 10-->
        </div>
        <div class="col-xxl-6 info-box">
            <!--begin::Engage widget 10-->
            <div class="card card-flush h-md-100">
                <!--begin::Body-->
                <div class="card-body d-flex flex-column mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0">
                    <!--begin::Illustration-->
                    <img class="mx-auto h-150px h-lg-200px theme-light-show" src="assets/img/s1.png" alt="">
                    <img style="border: 10px solid #a3a3a314;border-radius: 10px;padding: 10px;"
                        class="mx-auto h-150px h-lg-200px theme-dark-show" src="assets/img/s1.png" alt="">
                    <!--end::Illustration-->
                    <!--begin::Wrapper-->
                    <div class="mt-20">
                        <!--begin::Title-->
                        <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
                            <span class="me-2">تعلم بلا حدود مع أكاديميا
                                إبدأ بتطوير نفسك و تصفح مجموعة كبيرة من الدورات في عدة مجالات في
                                <br>

                                <span class="position-relative d-inline-block text-success">
                                    <a href="../../demo1/dist/pages/user-profile/overview.html"
                                        class="text-success opacity-75-hover"> أكاديما</a>
                                    <!--begin::Separator-->
                                    <span
                                        class="position-absolute opacity-15 bottom-0 start-0 border-4 border-success border-bottom w-100"></span>
                                    <!--end::Separator-->
                                </span></span> وانطلق
                        </div>
                        <span class="fw-semibold  text-center fs-6 mb-8 d-block opacity-75">
                            تطبيق أكاديميا يوفر تعليم عالي الجودة لطلاب المدارس الإعدادية والثانوية والجامعة. بفضل
                            ميزاته المميزة ونهجه التكنولوجي، يمكن للطلاب الوصول إلى محتوى تدريب متميز في أي وقت ومن أي
                            مكان.
                        </span>
                        <!--end::Title-->
                        <!--begin::Action-->

                        <!--begin::Action-->
                    </div>
                    <!--begin::Wrapper-->

                </div>
                <!--end::Body-->
            </div>
            <!--end::Engage widget 10-->
        </div>


    </div>
</template>

<script>
import Flickity from 'flickity';
import 'flickity/css/flickity.css'; // إذا كنت بحاجة إلى تضمين CSS الخاص بـ Flickity
export default {
    name: "infoDetails",
    data() {
        return {
            token: localStorage.getItem("access_token"),
            respo: localStorage.getItem("respo"),
        };
    },
    created() { },
    mounted() {
        this.$nextTick(() => {
            const carouselElement = this.$refs.carousel;
            if (carouselElement) {
                new Flickity(carouselElement, {
                    // إعدادات Flickity الخاصة بك
                    contain: true,
                    autoPlay: true,
                    wrapAround: true
                });
            } else {
                console.error('Carousel element not found');
            }
        });
    },
    methods: {

    },
};
</script>

<style scoped></style>
